import React from 'react';
import { PropTypes } from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles, AppBar } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { TestNativeFeatures } from '../../components';
import styles from './styles';
import AppRouter from '../../router/AppRouter/AppRouter';
import { AppHeader } from '../../components';
import data from '../../components/HourlyForecast/hourlyForecastData.json';

export class AppLayout extends React.Component {
  showVAWrapper = process.env.REACT_APP_SHOW_VA_WRAPPER === 'yes';
  testNativeFeatures = process.env.REACT_APP_TEST_NATIVE_FEATURES === 'yes';

  render() {
    const {
      classes: { appContainer, layoutContainer, appContent, footer, bottomBar, dateDay },
    } = this.props;
    const hourlyComp = window.location.href.indexOf('hourlyforecast')>0;
    const HourForecastDate = data.HourForecast[0].Date;
    const currentDayDate = new Date(HourForecastDate)
    const dateSplit = HourForecastDate.split (' ');
    const day = dateSplit[0];
    const currentDate = dateSplit[2];
    const month = currentDayDate.getMonth() + 1;
    let monthUpdate;
    if (month < 10) {
     monthUpdate = `0${month}`
    } else {
      monthUpdate = month
    }

    return (
      <React.Fragment>
        {this.renderAppNav()}
        <div className={layoutContainer}>
          {/* AppHeader and the content based on current route */}
          <div className={appContainer}>
            {this.renderAppHeader(hourlyComp)}
    <div className={appContent}>{hourlyComp &&  (<div className={dateDay}>{day} {monthUpdate}/{currentDate}</div>)}{AppRouter()}</div>
          </div>

          {/* show footer only if Native Features testing is to be enabled */}
          {this.testNativeFeatures && (
            <div className={footer}>
              <TestNativeFeatures />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }

  /**
   * @renderAppHeader
   * @description renders DOM for App Header
   */
  renderAppHeader = (hourlyComp) => {
    if (!this.showVAWrapper) {
      return null;
    }

    const {
      t,
      classes: { appHeader },
    } = this.props;

    // setting title to be moved to redux
    let title = t('screens.weather.current.title');
    if (window.location.href.toLowerCase().indexOf('fivedayforecast') > 0) {
      title = t('screens.weather.fivedayforecast.title');
    } else if (hourlyComp) {
      title = t('screens.weather.hourlyforecast.title');
    }

    return (
      <div className={appHeader}>
        <AppHeader title={title} />
      </div>
    );
  };

  /**
   * @renderAppNav
   * @description renders DOM for App Nav
   */
  renderAppNav = () => {
    if (!this.showVAWrapper) {
      return null;
    }

    const {
      classes: { topBar, closeButton, closeIcon },
    } = this.props;

    console.log('returning after check for this.showVAWrapper');
    return (
      <AppBar position="fixed" className={topBar}>
        <div className={closeButton}>
          <span>
            <ClearIcon className={closeIcon} />
          </span>
        </div>
      </AppBar>
    );
  };
}

AppLayout.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(AppLayout));
